import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'ECommerce', component: () => import('../views/ECommerce.vue') },
  { path: '/LoginPage', name: 'LoginPage', component: () => import('../views/LoginPage.vue') },
  { path: '/SignupPage', name: 'SignupPage', component: () => import('../views/SignupPage.vue') },
  { path: '/productView', name: 'productView', component: () => import('../views/product/productView.vue') },
  { path: '/product/:id', name: 'productPreview', component: () => import('../views/product/productPreview.vue'), props: true },
  { path: '/productPreview/:id', redirect: (to) => ({ name: 'productPreview', params: { id: to.params.id } }) },
  { path: '/productPreview', redirect: '/productView' },
  { path: '/productView/:id/ProductUpload', name: 'ProductUpload', component: () => import('../views/product/ProductUpload.vue') },
  { path: '/ClientProfile', name: 'ClientProfile', component: () => import('../views/ClientProfile.vue') },
  { path: '/cart', name: 'Cart', component: () => import('../views/CartView.vue') },
  { path: '/checkout', name: 'Checkout', component: () => import('../views/CheckoutView.vue') },
  { path: '/wishlist', name: 'Wishlist', component: () => import('../views/WishlistView.vue') },
  { path: '/orders', name: 'Orders', component: () => import('../views/OrdersView.vue') },
  { path: '/orders/:id', name: 'OrderDetail', component: () => import('../views/OrderDetailView.vue'), props: true },
  { path: '/admin', name: 'Admin', component: () => import('../views/AdminDashboard.vue') },
  { path: '/about', name: 'about', component: () => import('../views/AboutView.vue') },
  // Legacy category routes redirect to filtered products
  { path: '/ClothDetail', redirect: '/productView?type=cloth' },
  { path: '/ShoeDtail', redirect: '/productView?type=shoe' },
  { path: '/ElectronicsDetail', redirect: '/productView?type=electronics' },
  { path: '/BooksDetail', redirect: '/productView?type=book' },
  { path: '/BagsDetail', redirect: '/productView?type=cloth' },
  { path: '/AccessoriesDetail', redirect: '/productView' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() { return { top: 0 } },
})

export default router
